export default "__VITE_ASSET__uyFuNiTh__"